var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    x: "0px",
    y: "0px",
    width: "22px",
    height: "22px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.0417 9.9607 C 1.762 10.2508 1.762 10.7215 2.052 11.0203 L 8.8694 17.7879 C 9.1692 18.0681 9.6399 18.0681 9.9387 17.7879 C 10.2288 17.4881 10.2288 17.0183 9.9387 16.7283 L 4.4619 11.3035 L 19.8293 11.3035 C 20.2437 11.3035 20.5793 10.9677 20.5793 10.5535 C 20.5793 10.1393 20.2437 9.8035 19.8293 9.8035 L 4.3418 9.8035 L 9.9231 4.3162 C 10.2131 4.0164 10.2131 3.5467 9.9231 3.2566 C 9.6243 2.9666 9.1536 2.9666 8.8538 3.2566 L 2.0417 9.9607 Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow_back.40e3be6e729facd24a665edf8539375c.svg";
export { ForwardRef as ReactComponent };